import Header from '../../Header/Header';
import ErrorOops from '../../../assets/oops.png'
import { Link } from "react-router-dom";
import { useEffect, useState } from 'react';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import CardGif from '../../../components/Arthmate/Modules/BasicInfo/Cards 2.gif'
import Quick from '../../../components/Arthmate/Modules/BasicInfo/quick.svg'
import CreditCardPopupNew from '../../utility/creditcardpopup';
import NoCostBanner from '../../FINDOC/nocostbanner';

export default function RejectedScreen() {
    const [userId,setUserId]=useState('')
        const [crediCardemi, setcrediCardemi] = useState(false);
        const [showPopOver, setShowPopOver] = useState(false);
    
    useEffect(()=>{
const pathParts = window.location.href.split("/patient/RejectedScreen/");
    const userIdFromUrl = pathParts[1];
    if (userIdFromUrl && userIdFromUrl !== "*") {
       setUserId(userIdFromUrl) 
    }

    },[])
      const noBtnClick = () => {
        setShowPopOver(false)
    }

    return (
        <main>
            <Header progressBar="hidden" />
              <div className={`banner-wrapper`}>
<NoCostBanner userId={userId} setcrediCardemi={setcrediCardemi}/>

                    {/* <div style={{ background: '#EDFEEF', padding: '3px 14px', marginTop: '20px', borderRadius: '5px' }} onClick={() => setcrediCardemi(true)}>

                        <div style={{ display: 'flex', width: '100%', cursor: 'pointer', paddingTop: '10px' }} >
                            <div style={{ width: '15%' }}>
                                <img src={CardGif} style={{ width: '32px' }} />
                            </div>
                            <div style={{ width: '80%' }}>
                                No cost EMI on <b>credit cards </b>
                                <br />
                                <img src={Quick} style={{ width: '112px', marginTop: '5px' }} />
                            </div>
                            <div style={{ width: '5%', marginTop: '11px', color: '#45934a' }}>
                                <DoubleArrowIcon />
                            </div>
                        </div>
                    </div> */}
                </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <img src={ErrorOops} alt="" style={{ maxWidth: "40%", marginTop: "3rem" }} />
            </div>
            <p style={{ textAlign: "center", padding: "16px", fontSize: "16px", lineHeight: "22px", margin: "1rem 0" }}>We are extremely sorry!<br />We tried really hard but our<br />lending partners are not able<br />to approve your credit application.</p>
            <div style={{ padding: "12px", background: "#FAE1CD", borderRadius: "4px" }}>
                <p><strong>Possible reasons of not approving </strong></p>
                <ol style={{ padding: "1rem 0 1rem 1.5rem" }}>
                    <li>Insufficient credit score.</li>
                    <li>Existing loan or credit card accounts.</li>
                </ol>
                <b>You can try with your immediate relative applying on your behalf or check your eligibility after 90 days.</b>
            </div>
            {/* <p style={{textAlign:"center", margin:"1.5rem"}}>Please try again after 90 days.</p> */}
            <p style={{ textAlign: "center", margin: "1rem 0" }}>For more details and enquiries, reach out to us</p>
            <Link to={"tel:+918069489655"}> <button className="submit" style={{ color: "#514C9F", background: "#ECEBFF", marginTop: "0" }}>Contact support</button> </Link>
             {crediCardemi ?
                                <CreditCardPopupNew
                                    userId={userId}
                                    showPopOver={crediCardemi}
                                    setShowPopOver={setcrediCardemi}
                                    yesBtnText={"Okay, send the code."}
                                    noBtnText={"No, edit Aadhaar number"}
                                    noBtnClick={() => noBtnClick()}
                                /> : ""}
        </main>
    )
}